<template>
  <div style="position:absolute;left:0;top:0;right:0;bottom:0;display: flex;flex-direction: column;">
    <van-nav-bar
      class="backBox"
      title="预约详情"
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="content_box">
      <div class="order_detail_box">
        <div class="content-bg">
          <div class="room-address-time-parent">
            <div class="room-address-time-parent-2">
              <div class="appointment-address">{{ showAddress }}</div>
              <div class="appointment-time">使用时间：{{ showTime }}</div>
            </div>
            <div v-if="isDesignate" class="designate-tag">固定指派</div>
            <div
              v-if="canCancelPiano"
              class="cancel-appointment"
              @click="cancelAppointment"
            >
              取消预约
            </div>
          </div>
          <div class="line-parent">
            <div class="left-half-round"></div>
            <div class="imaginary-line"></div>
            <div class="right-half-round"></div>
          </div>
          <!-- 预约进行中 -->

          <div class="orderNotTimeout" v-if="!appointmentTimeEnd">
            <div class="qr-code-hint-parent">
              <div v-if="h5Config.funCfg.openPasswordOpenDoor" class="roomPassTit" @click="clickPassWord">
                <span :class="showPassOrQR === 1 ? 'passAndQRSel' : 'passAndQR'"
                  >门禁密码</span
                >
              </div>
              <div v-if="h5Config.funCfg.openQrCodeOpenDoor" class="roomQRTit" @click="clickQR">
                <span :class="showPassOrQR === 1 ? 'passAndQR' : 'passAndQRSel'"
                  >门禁二维码</span
                >
              </div>
              <div class="designate-failure-report" @click="failureReportMsg">
                故障上报
              </div>
              <!-- <div @click="openLockNumber">学号开锁</div> -->
            </div>
            <!-- 暂未审批 -->
          <div class="orderTimeout" v-if="!appointmentTimeEnd&&getOptions.apply_status==1">
            <div class="orderApplyStatusImg">
              <img src="../../assets/imgs/awaitOrder@2x.png" alt="" />
            </div>
            <span class="orderTimeoutTip">暂未审批，请联系管理员</span>
          </div>
          <!-- 审批拒绝 -->
          <div class="orderTimeout" v-if="!appointmentTimeEnd&&getOptions.apply_status==2">
            <div class="orderApplyStatusImg">
              <img src="../../assets/imgs/refuseOrder@2x.png" alt="" />
            </div>
            <span class="orderTimeoutTip">审批拒绝，请联系管理员</span>
          </div>
          <!-- 已审批同意 -->
          <div class="" v-if="!appointmentTimeEnd&&(getOptions.apply_status==3||getOptions.apply_status==undefined)">
            <!-- 数字密码区域 -->
            <div v-if="showPassOrQR === 1" class="qr-code-parent">
              <div class="roomPasswordBox">
                <div
                  class="passwordItem"
                  v-for="item in roomPasswordArr"
                  :key="item.id"
                >
                  <div>{{ item }}</div>
                </div>
              </div>

              <div v-if="roomPassword === '******'" class="get-password">
                暂不支持密码
              </div>
              <div
                v-if="roomPassword === ''"
                class="get-password"
                @click="clickGetPianoPassword"
              >
                获取密码
              </div>
            </div>
            <!-- 二维码区域 -->
            <div v-if="showPassOrQR === 0" class="qr-code-parent">
              <img
                v-if="!imgData || appointmentTimeEnd"
                class="qr-code example"
                src="../../assets/imgs/qr_code_placeholder.png"
              />
              <img
                v-else
                class="qr-code"
                :src="imgData"
                @click="previewQrCode"
              />
              <div
                v-if="imgData === undefined && !appointmentTimeEnd"
                class="get-qr-code"
              >
                <span>暂不支持二维码</span>
                <!-- <span v-if="imgData === undefined">暂不支持二维码</span> -->
                <!-- <span v-else>获取二维码</span> -->
              </div>
              <div
                v-if="!imgData && !appointmentTimeEnd"
                class="get-qr-code"
                @click="clickGetPianoQrCode"
              >
                <span>获取二维码</span>
              </div>
              <div
                v-if="appointmentTimeEnd"
                class="disabled-hint iconfont icon-yishixiao"
              ></div>
              <div v-if="imgData && !appointmentTimeEnd" class="scan-code-hint">
                将二维码对准门锁扫描区域开门
              </div>
              <div
                v-if="imgData && !appointmentTimeEnd"
                class="refresh_code"
                @click="clickGetPianoQrCode"
              >
                刷新二维码
              </div>
            </div>
            <div v-if="!ruleText" class="explain-box">
              <div class="explain-title">管理制度</div>
              <span class="explain-content">略</span>
            </div>
            <div v-else class="explain-box">
              <div class="explain-title">{{ ruleText.title }}</div>
              <pre class="explain-content" >{{ruleText.content}}
              </pre>
            </div>
          </div>
          </div>

          <!-- 预约结束 -->
          <div class="orderTimeout" v-if="appointmentTimeEnd">
            <div class="orderTimeoutImg">
              <img src="../../assets/imgs/orderTimeOut.png" alt="" />
            </div>
            <span class="orderTimeoutTip">当前预约已结束</span>
          </div>

        </div>

        <div
          v-if="(canDownPiano || canOpenLock) && settingDown && (getOptions.apply_status==3||getOptions.apply_status==undefined)"
          class="bottom-parent"
        >
          <div v-if="canOpenLock" class="number-lock-parent">
            <img
              src="../../assets/imgs/electronic_lock.png"
              @click="openLockNumber"
            />
            <div @click="openLockNumber">{{h5Config.textCfg.idNum}}开锁</div>
          </div>
          <div v-if="canDownPiano" class="go-on-piano-parent">
            <div class="go-on-piano-inner">
              <div class="down-piano" @click="checkDoorBtn">
                签退
              </div>
            </div>
          </div>
<!--          <div v-if="canContinuePiano || canDownPiano" class="go-on-piano-parent">-->
<!--            <div class="go-on-piano-inner">-->
<!--              <div class="go-on-piano" v-if="canContinuePiano" @click="goOnPiano">续约</div>-->
<!--              <div class="down-piano" v-if="canDownPiano" @click="checkDoorNext">-->
<!--                签退-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
          <!-- <div v-if="canContinuePiano" class="go-on-piano-parent">
            <div class="go-on-piano-inner"></div>
          </div>
          <div v-else-if="canDownPiano" class="go-on-piano-parent"></div> -->
        </div>

        <div
          v-if="showpPedivQrCode"
          class="prediv-qr-code-parent"
          @click="closePredivQrCode"
        >
          <image class="qr-code-prediv" :src="imgData"></image>
        </div>
        <div v-if="downPianoStep > 0" class="start-down-parent">
          <div class="rubbish-parent" v-if="downPianoStep == 1">
            <img
              class="rubbish-image"
              src="../../assets/imgs/down_piano_rubbish.png"
            />
            <div class="close-check" @click="closeRubbish">
              <van-icon name="cross" />
            </div>
            <span class="rubbish-hint">带好随身物品 检查是否有遗留垃圾</span>
            <div class="check-next" @click="checkDoorNext">确定</div>
          </div>
          <div v-if="downPianoStep == 3" class="check-door-parent">
            <div
              class="close-check iconfont icon-shanchu"
              @click="closeCheckDoor"
            ></div>
            <span class="check-door-hint">请在3分钟内离开房间 并关好房门</span>
            <div class="check-door-hint2">系统将在3分钟后为您进行签退操作</div>
            <div class="check-next" @click="downPiano">完成</div>
          </div>
          <div v-if="downPianoStep == 4" class="check-down-succeed">
            <div class="close-check" @click="closeDownSucceed">
              <van-icon name="cross" />
            </div>
            <img
              class="down-succeed-image"
              src="../../assets/imgs/down_piano_succeed.png"
            />
            <span class="down-succeed-hint">签退成功</span>
          </div>
          <div v-if="downPianoStep == 5" class="check-down-fail">
            <div class="close-check" @click="closeDownFail">
              <van-icon name="cross" />
            </div>
            <img
              class="down-fail-image"
              src="../../assets/imgs/appointment_fail.png"
            />
            <span class="down-fail-hint2">请关好房门</span>
          </div>
          <div v-if="downPianoStep == 6" class="check-down-fail">
            <div class="close-check" @click="closeDownFail">
              <van-icon name="cross" />
            </div>
            <img
              class="down-fail-image"
              src="../../assets/imgs/appointment_fail.png"
            />
            <span class="down-fail-hint"
              >签退失败{{ downFailMsg ? '，' + downFailMsg : '' }}</span
            >
          </div>
        </div>

        <div class="number-open-parent" v-if="showNumberOpen">
          <div class="student-number-parent">
            <div class="student-number-hint">请输入{{h5Config.textCfg.idNum}}后四位</div>

            <div
              class="student-number-input"
              v-for="(item, index) in studentNumber"
              :key="index"
            >
              {{ item }}
            </div>
            <img
              class="student-number-close"
              src="../../assets/imgs/close.png"
              @click="numberKeyboardClose"
            />
          </div>
          <div class="number-keyboard-parent">
            <div class="number-keyboard-left">
              <div
                v-for="(item, index) in numArr"
                :key="index"
                @click="numberAreaClick(item)"
              >
                {{ item &gt;= 0 && item &lt;= 8 ? item + 1 : '' }}
                {{ item == 10 ? '0' : '' }}
                <img
                  v-if="item == 11"
                  src="../../assets/imgs/keyboard-close.png"
                />
              </div>
            </div>
            <div class="number-keyboard-right">
              <div class="number-keyboard-delete" @click="numberKeyboardDelete">
                <img src="../../assets/imgs/keyboard-delete.png" />
              </div>
              <div
                class="number-keyboard-comfirm"
                @click="numberKeyboardComfirm"
              >
                确定
              </div>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </div>
      <div class="placeholderBox"></div>
    </div>
  </div>
</template>
<script>
import * as api from '../../api/api'
import * as common from '../../api/common'
import * as utils from '../../api/utils'
import { Toast, ImagePreview, Dialog } from 'vant'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      numArr: [],
      startEndTimeExplain: '',
      bookId: null,
      dataInfo: null,
      startTime: null,
      endTime: null,
      isCourse: false,
      showTime: '', // 显示预约时间
      showAddress: '', // 显示预约琴房位置
      downPianoStep: '-1', // 1检查窗户  2提示清理垃圾  3检测房门 4成功签退  5签退失败
      appointmentTimeEnd: false, // 预约是否已结束   根据后台反的预约状态
      canDownPiano: false, // 是否可以签退
      canOpenLock: false, // 是否可以开锁
      // canContinuePiano: false, // 是否可以续约
      canCancelPiano: false, // 是否可以取消预约
      imgData: '', // 二维码base64数据
      showpPeviewQrCode: false, // 显示预览二维码
      roomPassword: '', // 门禁密码
      roomPasswordArr: ['*', '*', '*', '*', '*', '*'], // 门禁密码数组
      closeCurPage: false, // 页面到前台时，是否关闭当前页面
      openDownPiano: false, // 打开页面签退
      downFailMsg: '',
      windowStatusTemp: false, // 签退窗磁状态临时记录 1开  0关
      doorStatusTemp: false, // 签退门磁状态临时记录 1开  0关
      isDesignate: false, // 是否是指派
      showGuide1: false,
      showGuide2: false,
      noHintGuide: false,
      oneShowHintGuide: false,
      timeInterval: null,
      initialBrightness: null, // 屏幕初始亮度
      ruleText: {
        title: ''
      },
      showNumberOpen: false,
      studentNumber: [
        '', '', '', ''
      ], // 输入学号
      settingDown: false,
      roomDeviceError: true,
      getOptions: {},
      showPassOrQR: 1,
      currentPosition: {},
      phoneSignInFlag: -1
      // timer: '',
      // timerValue: 0

    }
  },
  mounted () {
    Toast.loading({
      message: '加载中...',
      forbidClick: true
    })
    // if (this.h5Config.funCfg.openPasswordOpenDoor) {
    //   this.showPassOrQR = 1
    // } else if (this.h5Config.funCfg.openQrCodeOpenDoor) {
    //   this.showPassOrQR = 0
    // } else {
    //   this.showPassOrQR = -1
    // }
    const option = this.$route.query
    this.getOptions = this.$route.query
    console.log('接受参数', this.getOptions)

    this.getNumArr()
    const isCourse = Number(option.isCourse) === 1
    let dataInfo = null
    if (isCourse) {
      dataInfo = { id: option.bookId, room_id: option.roomId }
    } else {
      dataInfo = { room_id: option.roomId }
    }
    this.openDownPiano = option.downPiano
    this.bookId = option.bookId
    this.isCourse = isCourse
    this.dataInfo = dataInfo
    this.showTime = isCourse ? decodeURIComponent(option.showTime) : ''
    // this.showTime = option.showTime
    this.showAddress = isCourse ? decodeURIComponent(option.showAddress) : ''
    // this.showAddress = isCourse ? decodeURIComponent(option.showAddress) : ''
    this.getNotice()
    if (!this.isCourse) {
      let timeInterval = this.timeInterval
      if (timeInterval) {
        clearInterval(timeInterval)
      }
      timeInterval = setInterval(() => {
        this.refreshStatus()
      }, 1000)

      this.timeInterval = timeInterval
      this.getMyReserved()
    } else {
      Toast.clear()
    }
    this.getUpDownSetting()
  },
  computed: {
    ...mapState({
      h5Config: function (state) {
        const conf = state.h5Config.h5Config
        if (conf.funCfg.openPasswordOpenDoor) {
          this.showPassOrQR = 1
        } else if (conf.funCfg.openQrCodeOpenDoor) {
          this.showPassOrQR = 0
        } else {
          this.showPassOrQR = -1
        }
        return conf
      }
    })
  },
  methods: {

    async getCurrentPosition (para) {
      const positionInfo = await utils.getCurrentPosition()
      if (positionInfo.browserSupport && positionInfo.phoneSignInFlag) {
        if (para) {
          para.longitude = positionInfo.currentLongitude
          para.latitude = positionInfo.currentLatitude
          para.geolocation = positionInfo.geolocation
        }
        return positionInfo
      }
    },
    // 续约
    goOnPiano () {
      this.$router.push({
        path: '/continuePiano',

        query: {
          bookId: this.dataInfo.id,
          roomId: this.dataInfo.room_id,
          buildingNo: this.dataInfo.building_no,
          duration: this.dataInfo.hour,
          roomNo: encodeURIComponent(this.dataInfo.name),
          typeName: this.dataInfo.type_name,
          startTime: utils.formatTimeInterval(this.dataInfo.begin_time, '-', ':'),
          endTime: utils.formatTimeInterval(this.dataInfo.end_time, '-', ':')
        }
      })
    },

    previewQrCode () {
      // 二维码全屏预览
      ImagePreview([this.imgData])
    },
    clickPassWord () {
      this.showPassOrQR = 1
    },
    clickQR () {
      this.showPassOrQR = 0
    },
    // 获取二维码
    clickGetPianoQrCode () {
      Toast.loading({
        message: '请稍后...',
        forbidClick: true
      })
      this.getPianoQrCode()
    },
    numberKeyboardClose () {
      this.showNumberOpen = false
    },
    numberAreaClick (item) {
      const sn = this.studentNumber
      if (item >= 0 && item <= 8) {
        for (let i = 0; i < sn.length; i++) {
          if (sn[i] === '') {
            sn[i] = item + 1
            this.studentNumber = JSON.parse(JSON.stringify(sn))
            return
          }
        }
      } else if (item === 10) {
        for (let i = 0; i < sn.length; i++) {
          if (sn[i] === '') {
            sn[i] = 0
            this.studentNumber = JSON.parse(JSON.stringify(sn))
            return
          }
        }
      } else if (item === 11) {
        this.numberKeyboardClose()
      }
    },
    numberKeyboardDelete () {
      // const sn = this.studentNumber
      const sn = JSON.parse(JSON.stringify(this.studentNumber))
      for (let i = sn.length - 1; i >= 0; i--) {
        if (sn[i] !== '') {
          sn[i] = ''

          this.studentNumber = JSON.parse(JSON.stringify(sn))

          return
        }
      }
    },
    async numberKeyboardComfirm () {
      const that = this
      //  this.studentNumber = JSON.parse(JSON.stringify(that.studentNumber))
      const sn = JSON.parse(JSON.stringify(that.studentNumber))
      let studentNum = ''
      for (let i = 0; i < sn.length; i++) {
        if (sn[i] === '') {
          Toast('请输入' + this.h5Config.textCfg.idNum)
          return
        }
        studentNum += sn[i]
      }

      const loading = Toast.loading({
        message: '解锁中...',
        forbidClick: true
      })
      const para = {
        suffix_account: studentNum,
        book_id: that.dataInfo.id
      }
      try {
        await this.getCurrentPosition(para)
      } catch (e) {
        return this.getGeolocationError(e)
      }
      api
        .axiosRequest(api.urlList.studentNumberOpenLock, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {
            that.numberKeyboardClose()
            Toast.success('开锁成功')
            if (that.dataInfo.status === 1) {
              that.dataInfo.status = 5
            }
            that.refreshStatus()
          } else {
            Toast.fail({
              message: '开锁失败！' + res.msg,
              duration: 2000
            })
          }
        })
        .catch((e) => {
          console.log('error log:', e)
          loading.close()
        })
    },
    cancelAppointment () {
      this.$router.push({
        path: '/cancelAppointment',
        query: {
          bookId: this.dataInfo.id,
          roomId: this.dataInfo.room_id,
          buildingNo: this.dataInfo.building_no,
          duration: this.dataInfo.hour,
          roomNo: encodeURIComponent(this.dataInfo.name),
          typeName: this.dataInfo.type_name,
          startTime: utils.formatTimeInterval(this.dataInfo.begin_time, '-', ':'),
          endTime: utils.formatTimeInterval(this.dataInfo.end_time, '-', ':')
        }
      })
    },
    openLockNumber () {
      const sn = this.studentNumber
      for (let i = 0; i < sn.length; i++) {
        if (sn[i] !== '') {
          sn[i] = ''
        }
      }

      this.studentNumber = sn
      this.showNumberOpen = true
    },
    refreshStatus () {
      const that = this
      if (!that.dataInfo || that.isCourse || that.isDesignate) {
        return
      }

      const curTime = new Date().getTime()
      const dd = that.dataInfo

      let downlimit = 0
      try {
        const configData = JSON.parse(localStorage.getItem(common.keyConfigInfo))
        if (configData && configData.allow_delay_down_minutes) {
          downlimit = configData.allow_delay_down_minutes * 60 * 1000
        }
      } catch (e) {
        console.log(e)
      }
      let timestatus
      if (curTime < dd.set_startTime) {
        // 未开始
        timestatus = 1
      } else if (curTime >= dd.set_startTime && curTime < dd.set_endTime) {
        // 可签到时间段，签到后可签退时间段
        timestatus = 2
      } else if (curTime >= dd.set_endTime && curTime < (dd.set_endTime + downlimit)) {
        // 最后的签退时间段
        timestatus = 3
      } else {
        // 结束
        timestatus = 4
      }
      // | 1   | 正常预约   |
      // | 2   | 续琴     |
      // | 3   | 取消预约   |
      // | 4   | 取消重新预约 |
      // | 5   | 上琴&签到    |
      // | 6   | 下琴&签退     |
      // | 16   | 超时签到自动取消     |
      that.appointmentTimeEnd = (dd.status === 3 || dd.status === 6 || dd.status === 16) || timestatus >= 3
      that.canDownPiano = (dd.status === 2 || dd.status === 5) && timestatus <= 3

      that.canOpenLock = (dd.status === 1 || dd.status === 2 || dd.status === 5) && timestatus === 2 && this.h5Config.funCfg.openStudentIdOpenDoor
      that.canCancelPiano = dd.status === 1 && timestatus === 1
      Toast.clear()
    },
    getMyReserved () {
      const that = this
      const para = {
        book_id: that.getOptions.bookId
      }
      api
        .axiosRequest(api.urlList.historyOrder, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {
            if (res.list.length === 0) {
              Dialog.alert({
                title: '加载失败',
                message: '加载数据失败，返回上个界面'
              }).then(() => {
                // on close
                this.onClickLeft()
              })
              return false
            }
            const c = res.list[0]
            try {
              const str = c.name
              // eslint-disable-next-line no-useless-escape
              const index = str.lastIndexOf('\-')
              if (index >= 0) {
                c.name = str.substring(index + 1, str.length)
              }
            } catch (e) { }

            const startTime = utils.formatDate(c.begin_time)
            const endTime = utils.formatDate(c.end_time)
            c.set_startTime = startTime.getTime()
            c.set_endTime = endTime.getTime()
            let showTime

            if (c.status === 7) {
              showTime = utils.formatTimeYMDInterval(startTime, '/') + ' ' + utils.formatTimeHourMinutes(startTime) + ' - ' + utils.formatTimeYMDInterval(endTime, '/') + ' ' + utils.formatTimeHourMinutes(endTime)
            } else {
              showTime = utils.formatTimeMDChinese(startTime) + ' ' + utils.formatTimeHourMinutes(startTime) + ' - ' + utils.formatTimeHourMinutes(endTime)
            }

            const showAddress = c.building_no + c.name + ' ' + c.type_name

            that.startTime = startTime
            that.endTime = endTime
            that.dataInfo = c
            that.isDesignate = c.status === 7
            that.showTime = showTime
            that.showAddress = showAddress

            // that.dataInfo.status = c.status
            // ToDo
            // if (c.status === 1 && this.roomPassword) {
            //   // 已经获取到密码 且 还没签到 去定时刷新门的状态
            //   this.setIntervalStart()
            // }

            that.refreshStatus()

            if (that.canDownPiano && that.openDownPiano) {
              that.openDownPiano = false

              that.startDownPiano()
            }
          } else {
            utils.judgeBackMsg(res)
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },

    getUpDownSetting () {
      const that = this
      const para = {

      }
      api
        .axiosRequest(api.urlList.getUpDownSetting, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {
            if (!res.model ||
              res.model === 1 || // 不设设
              res.model === 3 || // 小程序
              res.model === 2003// 小程序和班排
            ) {
              that.settingDown = true
            } else {
              that.queryRoomEntranceDevice()
            }
          } else {
            utils.judgeBackMsg(res)
            this.ruleText = {
              title: ''
            }
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    checkDoorBtn () {
      this.downPianoStep = 1
    },
    // 签退
    checkDoorNext () {
      Toast.loading({
        message: '正在检测房门...',
        forbidClick: true
      })
      const that = this
      const para = {
        room_id: that.getOptions.roomId
      }
      api
        .axiosRequest(api.urlList.getDoorStatus, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {
            that.doorStatusTemp = res.is_open

            that.downPiano()
          } else {
            Toast.fail('失败')

            this.downPianoStep = 5
            this.doorStatusTemp = 1

            setTimeout(function () {
              that.downPiano()
            }, 1000)
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    startDownPiano () {
      this.downPianoStep = 1
    },
    closeDownFail () {
      this.downPianoStep = -1
    },
    closeDownSucceed () {
      this.onClickLeft()
    },
    closeCheckDoor () {
      this.downPianoStep = -1
    },
    closeRubbish () {
      this.downPianoStep = -1
    },
    async downPiano () {
      const loading = Toast.loading({
        duration: 3000,
        message: '签退中...',
        forbidClick: true
      })

      const that = this
      const para = {
        room_id: that.getOptions.roomId,
        book_id: that.getOptions.bookId,
        door_status: that.doorStatusTemp,
        window_status: that.windowStatusTemp || 1
      }
      try {
        await this.getCurrentPosition(para)
      } catch (e) {
        return this.getGeolocationError(e)
      }
      api
        .axiosRequest(api.urlList.downPiano, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {
            that.dataInfo.status = 6
            that.downPianoStep = 4
            that.refreshStatus()
          } else {
            Toast({
              type: 'fail',
              duration: 2000,
              message: '签退失败' + (res.msg ? ',' + res.msg : ''),
              forbidClick: true,
              onClose: () => {
                that.downFailMsg = res.msg
                this.downPianoStep = 6
              }
            })
          }
        })
        .catch((e) => {
          console.log('error log:', e)
          loading.close()
        })
    },
    // 查询门禁机设备状态
    queryRoomEntranceDevice () {
      const para = {
        room_id: this.dataInfo.room_id
      }
      api
        .axiosRequest(api.urlList.queryRoomEntranceDevice, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {
            if (!res.device_status || res.device_status === 0) {
              this.settingDown = true
            }
          } else {
            utils.judgeBackMsg(res)
            this.ruleText = {
              title: ''
            }
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    // 获取通知
    getNotice () {
      const para = {

      }
      api
        .axiosRequest(api.urlList.getNotice, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {
            this.ruleText = res
          } else {
            utils.judgeBackMsg(res)
            this.ruleText = {
              title: ''
            }
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    showpPedivQrCode () {

    },
    closePredivQrCode () {

    },
    // 故障上报
    failureReportMsg () {
      this.$router.push({
        path: './failureReport',
        query: {
          roomId: this.dataInfo.room_id,
          bookId: this.dataInfo.id
        }
      })
    },
    // 获取门禁密码
    clickGetPianoPassword () {
      Toast.loading({
        message: '请稍后...',
        forbidClick: true
      })
      // return
      this.getPianoQrCode()
      // this.getPianoPassword()
    },
    getPianoQrCode () {
      this.doGetAuth()
    },
    doGetAuth () {
      const that = this
      that.doGetPianoQrCode()
    },
    getCoursePianoQrCode (longitude, latitude) {
      const that = this
      const para = {
        room_id: that.dataInfo.room_id,
        book_id: that.dataInfo.id,
        longitude,
        latitude
      }
      api
        .axiosRequest(api.urlList.getPianoQrCodePassword, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {
            if (!res.password) {
              res.password = '******'
            }
            this.roomPasswordArr = res.password.split('')
            this.imgData = res.qrCodeBase64
            this.dataInfo = that.dataInfo
            this.roomPassword = res.password
          } else {
            Toast.fail(res.msg)
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
        .finally(() => {
          Toast.clear()
        })
    },
    async doGetPianoQrCode () {
      const that = this
      const para = {
        room_id: that.dataInfo.room_id,
        book_id: that.dataInfo.id,
        doorId: that.dataInfo.door_id_str
      }
      try {
        await this.getCurrentPosition(para)
      } catch (e) {
        this.getGeolocationError(e)
        return
      }
      if (this.isCourse) {
        this.getCoursePianoQrCode(para.longitude, para.latitude)
        return
      }
      const loading = Toast.loading({
        duration: 3000,
        message: '努力工作中...',
        forbidClick: true
      })

      api
        .axiosRequest(api.urlList.getPianoQrCodePassword, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {
            that.getMyReserved()
            if (!res.password) {
              res.password = '******'
            }
            this.roomPasswordArr = res.password.split('')
            this.imgData = res.qrCodeBase64
            this.dataInfo = that.dataInfo
            this.roomPassword = res.password

            that.refreshStatus()
          } else {
            Toast.fail({
              duration: 3000,
              message: '获取失败' + (res.msg ? ':' + res.msg : '')
            })
          }
        })
        .catch((e) => {
          loading.close()
          console.log('error log:', e)
        })
    },
    getNumArr () {
      for (let a = 0; a < 12; a++) {
        this.numArr.push(a)
      }
    },
    onClickLeft () {
      this.$router.go(-1)
    },
    // 定时刷新 是否开门任务
    // setIntervalStart () {
    //   this.timer = setInterval(this.refreshOpenDoor, 2000)
    // },
    // refreshOpenDoor () {
    //   this.timerValue++
    //   console.log('我再次刷新了门的状态')
    //   console.log('this.timerValue', this.timerValue)
    // },
    // setIntervalOver () {
    //   console.log('销毁循环定时器')
    //   clearInterval(this.timer)
    // }
    getGeolocationError (e) {
      let msg
      if (e && e.code === 1) {
        msg = '无法开启位置信息授权'
      }
      Toast({
        type: 'fail',
        duration: 3000,
        message: msg || e.message
      })
    }
  },
  beforeDestroy () {
    // this.setIntervalOver()
  }
}
</script>
<style scoped lang="scss">
body,
html {
}
#app {
  // height: 100vh;
  background-color: #60b3ff;
  // padding-bottom: 0 !important;
}
.bottomTab {
  // display: none !important;
}
.content_box {
  flex: 1;
  width: 100%;
  overflow: auto;
  background-color: #60b3ff;
  padding-top: 1rem;
 padding-bottom: 1rem;
 display:flex;
 flex-direction: column;
}
.order_detail_box {
  width: 100%;
}
.placeholderBox{
  flex: 1;
  background-color: #60b3ff;
}
.content-bg {
  height: 90%;
  display: flex;
  flex-direction: column;
  margin: 0 1rem 1rem;
  border-radius: 1rem;
  background-color: #fff;
}
.room-address-time-parent {
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  height: 6.5rem;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}
.room-address-time-parent-2 {
  margin: 0.4375rem 1.25rem 0 1.25rem;
  display: flex;
  flex-direction: column;
}
.appointment-address {
  font-size: 1.125rem;
  color: #333;
  font-weight: 550;
}
.appointment-time {
  margin-top: 1rem;
  font-size: 0.75rem;
  color: #666;
}
.cancel-appointment {
  margin: 0.4375rem 1.25rem 0 0;
  font-size: 0.875rem;
  color: #0487fe;
}
.line-parent {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.left-half-round {
  width: 0.625rem;
  height: 1.25rem;
  border-radius: 0 0.625rem 0.625rem 0;
  background-color: #60b3ff;
}
.imaginary-line {
  width: 19.3125rem;
  height: 0.0625rem;
  border-bottom: 0.0625rem dashed #d4d4d4;
}
.right-half-round {
  width: 0.625rem;
  height: 1.25rem;
  border-radius: 0.625rem 0 0 0.625rem;
  background-color: #60b3ff;
}
.qr-code-parent {
  display: flex;
  flex-direction: column;
  position: relative;
  margin-top: 1.25rem;
  align-items: center;
}
.qr-code {
  width: 15.625rem;
  height: 15.625rem;
}
.get-qr-code {
  position: absolute;
  margin-top: 6.375rem;
  width: 9.875rem;
  height: 2.875rem;
  line-height: 2.875rem;
  text-align: center;
  background-color: #fff;
  border-radius: 1.4375rem;
  color: #0487fe;
  border: 0.0625rem solid #0487fe;
}

.disabled-hint {
  position: absolute;
  margin-top: 0.9375rem;
  right: 3.75rem;
  font-size: 6.875rem;
  color: #a8a8a8;
}
.refresh_code {
  margin-top: 0.9375rem;
  font-size: 0.875rem;
  color: #0487fe;
}
.scan-code-hint {
  margin-top: 0.625rem;
  font-size: 0.875rem;
  color: #666;
}
.explain-title {
  margin-top: 3.5625rem;
  color: #333;
  font-size: 1.125rem;
  font-weight: 550;
  text-align: center;
}
.explain-content {
  padding: 1rem;
  font-size: 0.625rem;
  color: #666;
  letter-spacing: 0.0625rem;
  line-height: 0.9375rem;
  white-space: pre-line;
}
.bottom-parent {
  position: fixed;
  height: 4.375rem;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  flex-direction: row;
  background-color: #fff;
  box-shadow: 0px 0px 0.3125rem 0.3125rem rgba(1, 1, 1, 0.1);
}
.number-lock-parent {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 5.625rem;
  align-items: center;
  justify-content: center;
}
.number-lock-parent > img {
  width: 2rem;
  height: 2rem;
}
.number-lock-parent > div {
  margin-top: 0.25rem;
  font-size: 0.625rem;
  color: #333;
}
.go-on-piano-parent {
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 14.6875rem;
  align-items: center;
  justify-content: center;
}
.go-on-piano-inner {
  display: flex;
  flex-direction: row;
  border-radius: 1.5625rem;
  border: 0.0625rem solid #ff9d00;
  overflow: hidden;
}
.go-on-piano {
  box-sizing: border-box;
  height: 3.125rem;
  width: 8.4375rem;
  line-height: 3.125rem;
  text-align: center;
  font-size: 1.25rem;
  font-weight: 550;
  color: #ff9d00;
  background-color: #fff;
}

.down-piano {
  height: 3.125rem;
  width: 8.4375rem;
  line-height: 3.125rem;
  text-align: center;
  font-size: 1.25rem;
  font-weight: 550;
  color: #fff;
  background-color: #ff9d00;
}
.down-piano-only {
  width: 15.625rem;
  border-radius: 1.5625rem;
}
.start-down-parent {
  position: fixed;
  display: flex;
  flex-direction: row;
  justify-content: center;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: #00000066;
}
.close-check {
  position: absolute;
  top: 0;
  right: 0;
  line-height: 2.75rem;
  text-align: center;
  width: 2.75rem;
  height: 2.75rem;
  font-size: 1.25rem;
  color: #333;
}
.check-window-parent,
.rubbish-parent,
.check-door-parent,
.check-down-succeed,
.check-down-fail {
  position: relative;
  width: 18.125rem;
  height: 21.25rem;
  margin-top: 8.4375rem;
  background-color: #fff;
  border-radius: 0.375rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.check-window-parent {
  height: 16.875rem;
}
.check-down-succeed,
.check-down-fail {
  width: 17.5rem;
  height: 16.875rem;
}
.check-window-image {
  margin-top: 4.1875rem;
  width: 10.125rem;
  height: 6.625rem;
}
.check-window-hint {
  margin-top: 1.875rem;
  font-size: 1.125rem;
  color: #333;
  letter-spacing: 0.125rem;
}
.check-window-hint2 {
  margin-top: 1.25rem;
  font-size: 0.875rem;
  color: #888;
}
.check-next {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 3.375rem;
  font-size: 1.375rem;
  font-weight: 500;
  line-height: 3.375rem;
  text-align: center;
  color: #fff;
  background-color: #ff9d00;
  border-radius: 0 0 0.375rem 0.375rem;
}
.rubbish-image {
  width: 8.75rem;
  height: 7rem;
  margin-top: 4.25rem;
}
.rubbish-hint {
  padding: 0 1rem ;
  font-size: 1.125rem;
  color: #333;
  text-align: center;
  margin-top: 1.25rem;
  line-height: 1.6875rem;
  letter-spacing: 0.125rem;
}
.check-door-hint {
  font-size: 1.125rem;
  color: #333;
  text-align: center;
  margin-top: 7.5rem;
  line-height: 1.6875rem;
  letter-spacing: 0.125rem;
}
.check-door-hint2 {
  margin-top: 1.125rem;
  font-size: 0.75rem;
  color: #666;
}
.down-succeed-image {
  margin-top: 4.4375rem;
  width: 6.625rem;
  height: 5.875rem;
}
.down-succeed-hint {
  font-size: 1.125rem;
  color: #333;
  margin-top: 1.4375rem;
}
.down-fail-image {
  margin-top: 5rem;
  width: 4.625rem;
  height: 4.8125rem;
}
.down-fail-hint {
  font-size: 1.125rem;
  color: #333;
  text-align: center;
  margin-left: 0.9375rem;
  margin-right: 0.9375rem;
  margin-top: 1.625rem;
}
.down-fail-hint2 {
  font-size: 0.875rem;
  color: #666;
  margin-top: 0.3125rem;
}
.preview-qr-code-parent {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: #00000066;
}
.qr-code-preview {
  width: 18.75rem;
  height: 18.75rem;
}

.designate-tag {
  position: absolute;
  box-sizing: border-box;
  right: 0;
  top: 1.375rem;
  width: 4.75rem;
  height: 1.75rem;
  line-height: 1.75rem;
  padding-left: 0.625rem;
  font-size: 0.75rem;
  font-weight: 550;
  color: #1a984e;
  background-color: #ecfbf2;
  border-radius: 0.9375rem 0 0 0.9375rem;
}

.qr-code-hint-parent {
  position: relative;
  margin: 1rem 1.25rem 0 1.25rem;
  margin-top: 1rem;
  margin-left: 1.25rem;
  display: flex;
  align-items: center;
  .roomQRTit {
    margin-left: 1.5625rem;
  }
}

.qr-code-hint {
  font-size: 1.125rem;
  font-weight: 550;
  color: #333;
}

.designate-failure-report {
  position: absolute;
  right: 0;
  font-size: 0.875rem;
  color: #0487fe;
}

.guide-layout-parent {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: #00000066;
}
.guide-layout {
  width: 18.125rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #333;
  border-radius: 0.375rem;
  background-color: #fff;
}
.guide-layout-1 :nth-child(1) {
  font-size: 0.875rem;
  margin: 1.125rem 0 0 0;
}
.guide-layout-1 :nth-child(2) {
  width: 15rem;
  height: 10rem;
}
.guide-layout-1 :nth-child(3) {
  font-weight: 550;
  font-size: 1rem;
  margin: 1.5625rem 0 1.0625rem 0;
}
.guide-layout-1 :nth-child(4) {
  width: 100%;
  height: 3.375rem;
  line-height: 3.375rem;
  text-align: center;
  font-size: 1.375rem;
  color: #fff;
  border-radius: 0 0 0.375rem 0.375rem;
  background-color: #ff9d00;
}

.guide-layout-2-1 {
  font-size: 0.875rem;
  margin: 1.125rem 0 0.9375rem 0;
}
.guide-layout-2-2 {
  width: 15rem;
  height: 10rem;
}
.guide-layout-2-3 {
  font-size: 1rem;
  font-weight: 550;
  margin: 1.25rem 0 1rem 0;
}
.guide-layout-2-4 {
  font-size: 0.625rem;
  color: #666;
  margin-bottom: 20px;
}
.guide-layout-2-5 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 2.1875rem;
  background-color: #f8f8f8;
}
.guide-layout-2-5 > view {
  margin-left: 0.125rem;
  font-size: 0.75rem;
  color: #666;
}
.guide-layout-2-6 {
  width: 100%;
  height: 3.375rem;
  line-height: 3.375rem;
  text-align: center;
  font-size: 1.375rem;
  color: #fff;
  border-radius: 0 0 0.375rem 0.375rem;
  background-color: #ff9d00;
}

.number-open-parent {
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  color: black;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: #00000066;
}
.student-number-parent {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 18.125rem;
  padding: 1.875rem 0 2.1875rem 0;
  margin-bottom: 7rem;
  background: white;
  border-radius: 0.875rem;
}
.student-number-close {
  position: absolute;
  width: 1.125rem;
  height: 1.125rem;
  right: 0.75rem;
  top: 0.625rem;
}
.student-number-hint {
  width: 100%;
  text-align: center;
  margin-bottom: 1.25rem;
  font-size: 1.125rem;
}
.student-number-input {
  width: 2.5rem;
  height: 2.5rem;
  line-height: 2.5rem;
  text-align: center;
  margin: 0 0.75rem 0 0.75rem;
  font-size: 1.125rem;
  border: 0.0625rem solid #979797;
}
.number-keyboard-parent {
  width: 100%;
  display: flex;
  background: white;
}
.number-keyboard-left {
  width: 75%;
  display: flex;
  flex-wrap: wrap;
}
.number-keyboard-left > div {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 33.3%;
  height: 2.8125rem;
  font-size: 1.25rem;
  box-sizing: border-box;
  border-bottom: #d7d7d7 solid 0.0625rem;
  border-right: #d7d7d7 solid 0.0625rem;
}
.number-keyboard-left:nth-child(10),
.number-keyboard-left:nth-child(11),
.number-keyboard-left:nth-child(12) {
  border-bottom: none;
}
.number-keyboard-left > div > img {
  width: 2.1875rem;
  height: 1.5625rem;
}
.number-keyboard-right {
  width: 25%;
  display: flex;
  flex-direction: column;
}
.number-keyboard-delete {
  height: 50%;
  line-height: 5.625rem;
  text-align: center;
  font-size: 1.25rem;
}
.number-keyboard-delete > img {
  width: 1.75rem;
  height: 1.3125rem;
}
.number-keyboard-comfirm {
  height: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  color: white;
  background: #118eea;
}

/* add */
.roomPasswordBox {
  width: 100%;
  /* height: 100%; */
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.passwordItem {
  width: 2.8125rem;
  height: 3.75rem;
  background-color: #eee;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  color: #333;
}
.get-password {
  // position: absolute;
  margin-top: 3.6875rem;
  line-height: 2.875rem;
  text-align: center;
  color: #0487fe;
}

// 门禁选中
.passAndQR {
  font-size: 0.875rem;
  color: #666;
}
// 门禁未选中
.passAndQRSel {
  font-size: 1.125rem;
  font-weight: 550;
  color: #333;
}

.orderTimeout {
  // text-align: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: 5rem;
  margin-bottom: 5rem;
  .orderTimeoutImg {
    width: 7.375rem;
    height: 10.375rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .orderApplyStatusImg {
    // width: 7.375rem;
    height: 10.375rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .orderTimeoutTip {
    color: #999;
    font-size: 0.875rem;
    margin-top: 1rem;
  }
}
</style>
